import React, { useEffect, useState } from "react";
import axios from "axios";
import FaqList from "./FaqList";
import "./style.css";
// assets
import search from "../../Assets/Icon feather-search.png";
import Footer from "../../Layout/Footer";
import Loader from "../../Components/Loader";
const Faq = () => {
  const [data, setData] = useState();
  useEffect(async () => {
    const faq = await axios.get("https://staging-cms-main.ipurvey.com/faq");
    const layout = await axios.get(
      "https://staging-cms-main.ipurvey.com/layout"
    );
    setData([faq.data, layout.data]);
  }, []);
  if (data) {
    return (
      <>
        <div className="Faq_container">
          <div className="faq_md">
            <div className="faq_sd">
              <div className="sub_header_md">
                <h4> Frequently Asked Questions</h4>
                <div className="faq_search_md">
                  <input type="text" placeholder="Search" />
                  <img src={search} alt="..." />
                </div>
              </div>
              <FaqList data={data[0]} />
            </div>
          </div>
        </div>
        <Footer data={data[1]} />
      </>
    );
  } else return <Loader />;
};

export default Faq;
